import { dateTimeAsUTCWithoutCompensation } from '../../../../helpers/date'
import { isUserAdminInSociety } from '../../../../helpers/society'
import { useAuthenticatedUserId } from '../../../../hooks/useAuthenticatedUserId'
import { IBookingModel } from '../../../../interfaces/models/bookings.interfaces'
import { ISocietiesModel } from '../../../../interfaces/models/societies.interfaces'

export const useDeleteBookingAllowed = (
  booking: IBookingModel,
  society?: ISocietiesModel
): { allowed: boolean; otherUsersOwnsBooking: boolean } => {
  const userId = useAuthenticatedUserId() as string
  const authenticatedUserOwnsBooking = booking?.userId === userId
  const userIsAdmin = isUserAdminInSociety(society, userId)
  const bookingIsInThePast =
    new Date(booking?.endDate) < dateTimeAsUTCWithoutCompensation(new Date())

  return {
    allowed:
      !bookingIsInThePast && (authenticatedUserOwnsBooking || userIsAdmin),
    otherUsersOwnsBooking: !authenticatedUserOwnsBooking,
  }
}
